import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const hasCarrierServices = {
  name: "hasCarrierServices" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ hasCarrierServices: z.boolean() }),
};
